import { Component, HostBinding, Inject, Input, OnInit } from '@angular/core';
import { IModalsService, IMODALS_SERVICE, P500UIBaseModal } from '@platform500services/p500-ui-kit';
import { CardData } from '../../components/base-metric-card/base-metric-card.component';
import { MetricTypesEnum } from '../../../modules/settings/terms/enums/metric-types.enum';
import { IMetricsService } from '../../../modules/settings/crm-metrics/services/metrics-service.interface';
import { DestroySubscribers } from '../../decorators/destroy-subscribers.decorator';
import { Router } from '@angular/router';

@Component({
  templateUrl: './metric-info.modal.html',
})
@DestroySubscribers()
export class MetricInfoModal extends P500UIBaseModal implements OnInit {
  @HostBinding('class') get className() {
    return `p500-ui-modal p500-ui-modal--primary p500-ui-modal--small c-modal c-modal--info`;
  }
  @Input() data: MetricInfoModalData;
  @Input() onClose: () => void = () => {};
  public isLoading = true;
  public metricData: CardData;

  public metricTypes = MetricTypesEnum;

  constructor(
    @Inject(IMODALS_SERVICE) public modalsService: IModalsService,
    @Inject('IMetricsService') private metricsService: IMetricsService,
    public router: Router
  ) {
    super(modalsService, router);
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.subscribers.metricsSettings = this.metricsService.getMetricsSettings().subscribe((data: any) => {
      this.metricData = { ...this.data.metric };
      const model = data?.models?.filter((model) => model.model === this.data?.metric?.model)?.[0];
      const target = model?.targets?.filter((target) => target.target === this.data?.metric?.target)?.[0];
      const aggregate = target?.aggregates?.filter((aggregate) => aggregate.aggregate === this.data?.metric?.aggregate)?.[0];
      const format = data?.formats[0]?.filter((format) => format.namespace === this.data?.metric?.format)?.[0];

      this.metricData.model = model?.name ?? '';
      this.metricData.target = target?.label ?? '';
      this.metricData.aggregate = aggregate?.label ?? '';
      this.metricData.format = format?.label ?? '';

      this.isLoading = false;
    });
  }

  closeModal(): void {
    this.onClose();
    this.modalsService.close(this.uniqueId);
  }
}

export interface MetricInfoModalData {
  metric: CardData;
}
